// extracted by mini-css-extract-plugin
module.exports = {"annotators":"Annotators_annotators__3tUlp","dl":"Annotators_dl__3w5YQ","container":"Annotators_container__cZH47","dt":"Annotators_dt__48WM3","dd":"Annotators_dd__3ntRr"};